export const firebaseConfig = {
    apiKey: "AIzaSyBC3qZ0kBW9vvp_yl1UpPd8K1yotayuWOc",
    authDomain: "vutreshen-glas.firebaseapp.com",
    databaseURL: "https://vutreshen-glas.firebaseio.com",
    projectId: "vutreshen-glas",
    storageBucket: "vutreshen-glas.appspot.com",
    messagingSenderId: "270542381887",
    appId: "1:270542381887:web:e65dfe4d9018b32d80298a",
    measurementId: "G-WB4BVW8S4S"
};